import FilterItemBasicCheckbox from './components/CheckElements/Checkbox/index.js'
import FilterItemBasicImage from './components/CheckElements/Image/index.js'
import FilterItemBasicRadioButton from './components/CheckElements/RadioButton/index..js'
import FilterItemBasicSwitch from './components/CheckElements/Switch/index.js'

export const BASE_CLASS = 'mt-FilterItemBasic'

export const CHECK_ELEMENT_IMAGE_CLASS_NAME = `${BASE_CLASS}-image`
export const CHECK_ELEMENT_IMAGE_WRAPPER_CLASS_NAME = `${CHECK_ELEMENT_IMAGE_CLASS_NAME}Wrapper`
export const CHECK_ELEMENT_IMAGE_OPACITY_CLASS_NAME = `${CHECK_ELEMENT_IMAGE_CLASS_NAME}--opacity`

export const NO_OP = () => {}

export const DESIGNS = {
  FLAT: 'flat',
  FLAT_OUTLINED: 'flatOutlined',
  OUTLINED: 'outlined',
  ROUNDED_OUTLINED: 'roundedOutlined'
}

export const DIRECTIONS = {
  COLUMN_REVERSE: 'columnReverse',
  ROW_REVERSE: 'rowReverse'
}

export const CHECK_ELEMENT_TYPES = {
  CHECKBOX: 'checkbox',
  IMAGE: 'image',
  NONE: 'none',
  RADIO_BUTTON: 'radioButton',
  SWITCH: 'switch'
}

export const CHECK_ELEMENTS = {
  [CHECK_ELEMENT_TYPES.CHECKBOX]: <FilterItemBasicCheckbox />,
  [CHECK_ELEMENT_TYPES.IMAGE]: <FilterItemBasicImage />,
  [CHECK_ELEMENT_TYPES.RADIO_BUTTON]: <FilterItemBasicRadioButton />,
  [CHECK_ELEMENT_TYPES.SWITCH]: <FilterItemBasicSwitch />
}

const BASE_ELEMENT_TYPES = {
  BUTTON: 'button',
  DIV: 'div',
  LABEL: 'label',
  OPTION: 'option'
}

export const WRAPPER_PROPS_BY_CHECK_ELEMENT_TYPE = {
  [CHECK_ELEMENT_TYPES.CHECKBOX]: {
    as: BASE_ELEMENT_TYPES.LABEL
  },
  [CHECK_ELEMENT_TYPES.IMAGE]: {
    as: BASE_ELEMENT_TYPES.LABEL
  },
  [CHECK_ELEMENT_TYPES.RADIO_BUTTON]: {
    as: BASE_ELEMENT_TYPES.LABEL
  },
  [CHECK_ELEMENT_TYPES.SWITCH]: {
    as: BASE_ELEMENT_TYPES.DIV
  }
}

export const getCheckElementWrapperProps = ({checkElementType}) => WRAPPER_PROPS_BY_CHECK_ELEMENT_TYPE[checkElementType]

export const getDefaultWrapperProps = ({isDisabled, isSelected, onChange}) =>
  isDisabled
    ? {
        as: BASE_ELEMENT_TYPES.DIV,
        'aria-disabled': true
      }
    : {
        as: BASE_ELEMENT_TYPES.DIV,
        onClick: onChange,
        onKeyDown: event => {
          if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault()
            onChange(event)
          }
        },
        role: BASE_ELEMENT_TYPES.BUTTON,
        tabIndex: 0,
        ...(isSelected && {'aria-selected': true})
      }

export const getWrapperProps = ({checkElementType, isDisabled, isSelected, onChange}) =>
  checkElementType === CHECK_ELEMENT_TYPES.NONE
    ? getDefaultWrapperProps({isDisabled, isSelected, onChange})
    : getCheckElementWrapperProps({checkElementType})
